import React, { useRef, useState } from 'react';
import { CustomVerification } from '../components';
import BottomNavigation from '../navigation/BottomNavigation';
import TopNavigation from '../navigation/TopNavigation';
import { Toast } from 'primereact/toast';

export const Verification = (props) => {
    const toast = useRef(null);


    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');


    return (

        <div className='root-landing'>
            <Toast ref={toast} />

            <div className="grid grid-nogutter surface-login-main p-2" >

                <TopNavigation {...props} />
                <BottomNavigation {...props} />

                <div className="container-fluid" style={{ maxWidth: 650 }}>
                    <CustomVerification toast={toast} {...props}

                        email={email} setEmail={setEmail}
                        userName={userName} setUserName={setUserName}
                        password={password} setPassword={setPassword}
                        passwordConfirm={passwordConfirm} setPasswordConfirm={setPasswordConfirm}
                    ></CustomVerification>
                </div>
            </div>
        </div>

    );
};
